<template>
  <label class="radio">
    <input
      type="radio"
      :name="name"
      :value="value"
      :checked="checked === true"
      @change="$emit('update', value)"
    >
    <span class="fake-radio"></span>
    <span class="radio-label">{{label}}</span>
  </label>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
    },
    label: {
      type: String,
    },
    value: {
      type: Boolean,
    },
    checked: {
      type: Boolean,
    },
  },
};
</script>

<style scoped>
input {
  display: none;
}

input:checked + .fake-radio::after {
  content: '';
  width: 20px;
  height: 20px;
  position: absolute;
  top: 9px;
  left: 9px;
  right: 9px;
  bottom: 9px;
  background-color: var(--blue-25);
  border-radius: 50%;
}

input:checked ~ .radio-label {
  font-weight: bold;
}

.radio {
  display: flex;
  align-items: center;
}

.fake-radio {
  display: block;
  background-color: var(--blue-05);
  border: 1px solid var(--blue-15);
  width: 38px;
  height: 38px;
  border-radius: 50%;
  margin-right: 20px;
  position: relative;
}

.radio-label {
  color: var(--blue-25);
  font-family: 'Univers LT W01 55 Roman';
}
</style>
